module.exports = __webpack_public_path__ + "static/media/cyber-security-green.0747e884.gif";